import {appUrl} from '@frontend/AppUrl'
import {LocalStorage} from '@frontend/services/LocalStorage'
import type {AnyObject} from '@frontend/types/AppTypes'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import type {
    AdCategory,
    FilteredItemsPageUrlQueryParams,
    ItemsCategoryOrLocationForBreadcrumbs,
} from '../modules/public/ads/AdsModuleTypes'

// Собрать URL к списку объявлений или услуг (в зависимости от category).
export function makeItemsListUrl(
    category: null | Pick<AdCategory, 'id' | 'slug' | 'type'> | ItemsCategoryOrLocationForBreadcrumbs,
    queryArgs?: Partial<FilteredItemsPageUrlQueryParams>
): string {
    // Очистка от пустых значений
    const queryArgsFiltered: AnyObject<string> = {}
    for (const key in queryArgs) {
        const value = queryArgs[key as keyof FilteredItemsPageUrlQueryParams]
        if (!value || String(value).trim() === '') {
            continue
        }
        queryArgsFiltered[key] = String(value).trim()
    }
    if (!('location' in queryArgsFiltered)) {
        queryArgsFiltered.location = String(LocalStorage.getFilterLocationId() ?? 0)
    }

    if (!category) {
        return NavigationService.makeUrl(appUrl().ads.all, null, queryArgsFiltered)
    } else {
        if ('breadcrumbType' in category && category.breadcrumbType === 'location') {
            // Передан объект AdsCategoryOrLocationForBreadcrumbs с type = 'location'
            queryArgsFiltered.location = String(category.id)
            return NavigationService.makeUrl(appUrl().ads.all, null, queryArgsFiltered)
        }
        return NavigationService.makeUrl(
            category.type === 'services' ? appUrl().services.category : appUrl().ads.category,
            {
                id: category.id,
                slug: category.slug,
            },
            queryArgsFiltered
        )
    }
}
